import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import {
  SEARCH_AUTO_SUGGEST_BY_TERM,
  SEARCH_ITEMS,
  SEARCH_RESULTS_APPEND,
  SEARCH_RESULTS_CLEAR,
  SEARCH_RESULTS_INIT,
  SEARCH_SUGGEST_COLLEGE,
  SEARCH_SUGGEST_MAJOR,
  SEARCH_SUGGEST_OCCUPATION
} from '../actions/search'
import { restReducer } from '../h2Api'
import { SYSTEM_MENU_LOADED, SYSTEM_MENU_SET_LOCAL } from '../actions/menu'

const initialSystemMenu = {
  sections: []
}
const initialSearchFilter = {}
const initialResultState = {
  results: []
}
const menuReducer = (state = initialSystemMenu, action) => {
  switch (action.type) {
    case SYSTEM_MENU_SET_LOCAL:
      return {
        ...state,
        ...action.sections
      }
    default:
      return state
  }
}
const resultHolderReducer = (state = initialResultState, action) => {
  switch (action.type) {
    case SEARCH_RESULTS_INIT:
      console.log('SETTING TO: ', action)

      return {
        ...state,
        results: action.items
      }
    case SEARCH_RESULTS_APPEND:
      console.log('NEW: ', [...state.results, ...action.items])

      return {
        ...state,
        results: [...state.results, ...action.items]
      }
    case SEARCH_RESULTS_CLEAR:
      return {
        ...state,
        results: []
      }
    default:
      return state
  }
}
const search = combineReducers({
  occupationSuggestionsRequest: restReducer(SEARCH_SUGGEST_OCCUPATION),
  majorSuggestionsRequest: restReducer(SEARCH_SUGGEST_MAJOR),
  collegeSuggestionsRequest: restReducer(SEARCH_SUGGEST_COLLEGE),
  searchRequest: restReducer(SEARCH_ITEMS),
  autoSuggestRequest: restReducer(SEARCH_AUTO_SUGGEST_BY_TERM),
  systemMenuRequest: restReducer(SYSTEM_MENU_LOADED),
  menuReducer,
  resultHolderReducer,
  searchFilterForm: modelReducer('search.searchFilterForm', initialSearchFilter),
  forms: formReducer('search', {
    searchFilterForm: initialSearchFilter
  })
})

export default search
